<p-dialog
  [(visible)]="usageService.creditCheckDialogVisible"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{'width': '500px'}"
  (onHide)="onClose()"
>
  <ng-template #header>
    <div class="flex items-center gap-2">
      <i class="pi pi-exclamation-triangle text-orange-500 text-xl"></i>
      <span class="text-lg font-semibold">Out of Credits</span>
    </div>
  </ng-template>

  <div class="p-4">
    @if(!hasSubscription()) {
      <!-- No subscription - show upgrade message -->
      <div class="text-center">
        <div class="mb-4">
          <i class="pi pi-credit-card text-4xl text-blue-500 mb-3"></i>
          <h3 class="text-xl font-bold mb-2">Free Credits Exhausted</h3>
          <p class="text-gray-600 dark:text-gray-300 mb-4">
            You've used all your free credits. To continue using our advanced features,
            you'll need to upgrade to a paid subscription.
          </p>
        </div>

        <div class="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-4">
          <h4 class="font-semibold text-blue-800 dark:text-blue-200 mb-2">What you'll get:</h4>
          <ul class="text-sm text-blue-700 dark:text-blue-300 space-y-1">
            <li class="flex items-center gap-2">
              <i class="pi pi-check text-green-500"></i>
              <span>Unlimited access to AI-powered research tools</span>
            </li>
            <li class="flex items-center gap-2">
              <i class="pi pi-check text-green-500"></i>
              <span>Advanced analytics and insights</span>
            </li>
            <li class="flex items-center gap-2">
              <i class="pi pi-check text-green-500"></i>
              <span>Priority customer support</span>
            </li>
          </ul>
        </div>
        <p-button
          label="Go to Billing Plans"
          severity="info"
          (click)="onClose()"
          icon="pi pi-credit-card"
          [routerLink]="'/app/billing/plans'">
        </p-button>
      </div>
    } @else {
      <!-- Has subscription - show renewal info -->
      <div class="text-center">
        <div class="mb-4">
          <i class="pi pi-calendar text-4xl text-orange-500 mb-3"></i>
          <h3 class="text-xl font-bold mb-2">Monthly Credits Exhausted</h3>
          <p class="text-gray-600 dark:text-gray-300 mb-4">
            You've used all your credits for this billing period.
            Your credits will reset on your next billing cycle.
          </p>
        </div>

        <div class="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-4 mb-4">
          <div class="flex justify-between items-center mb-2">
            <span class="font-semibold text-orange-800 dark:text-orange-200">Next Renewal:</span>
            <span class="text-orange-700 dark:text-orange-300">
              @if(daysUntilRenewal() !== null) {
                @if(daysUntilRenewal() === 0) {
                  Today
                } @else if(daysUntilRenewal() === 1) {
                  Tomorrow
                } @else {
                  {{daysUntilRenewal()}} days
                }
              } @else {
                {{subscriptionEndDate() | date:'mediumDate'}}
              }
            </span>
          </div>
          <div class="text-sm text-orange-700 dark:text-orange-300">
            <div class="flex justify-between">
              <span>Credits Used:</span>
              <span>{{creditsUsed() | number}} / {{totalCreditLimit() | number}}</span>
            </div>
          </div>
        </div>

        <div class="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-4">
          <h4 class="font-semibold text-blue-800 dark:text-blue-200 mb-2">Need more credits?</h4>
          <p class="text-sm text-blue-700 dark:text-blue-300 mb-3">
            You can upgrade your plan to get more credits or add prepaid credits to your account.
          </p>
        </div>
      </div>
    }
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button
        label="Close"
        severity="secondary"
        (onClick)="onClose()"
      ></p-button>
      @if(!hasSubscription()) {
        <p-button
          label="Upgrade Now"
          severity="primary"
          icon="pi pi-arrow-up"
          (onClick)="onUpgrade()"
        ></p-button>
      } @else {
        <p-button
          label="Manage Billing"
          severity="primary"
          icon="pi pi-cog"
          (onClick)="onManageBilling()"
        ></p-button>
      }
    </div>
  </ng-template>
</p-dialog>
